export default class EventObject {


  static _objectDefinition() {
    return {
      startTime: '',
      endTime: '',
      subEventId: '',
      name: '',
      entranceFee: '',
      hours: '',
      minutes: '',
      seconds: '',
      startHours: '',
      startDate: '',
      endDate: '',
      endHours: '',
      selected: '',
      paymentStatus: ''
    }
  }


  static _parseEventDataToObject(event) {


    let object = this._objectDefinition();

    object.startTime = event["StartTime"].value;
    object.startDate = new Date(object.startTime * 1000);
    object.paymentStatus = event["PaymentStatus"].value;
    // Hours part from the timestamp
    object.hours = object.startDate.getHours();
    object.minutes = "0" + object.startDate.getMinutes();
    // Seconds part from the timestamp
    // object.seconds = "0" + object.startDate.getSeconds();
    object.startHours = object.hours + ':' + object.minutes.substr(-2);
    object.endTime = event["EndTime"].value;
    object.endDate = new Date(object.endTime * 1000);
    object.hours = object.endDate.getHours();
    object.minutes = "0" + object.endDate.getMinutes();
    // Seconds part from the timestamp
    object.endHours = object.hours + ':' + object.minutes.substr(-2);
    object.subEventId = event["Id"].value;
    object.name = event["Name"].value;
    let status = event["Selected"].value
    object.selected = status.toLowerCase() == 'true' ? true : false;
    if (event["Data"].hasOwnProperty('EntranceFee')) {
      object.entranceFee = event["Data"]["EntranceFee"].value;
    }

    return object;
  }
}
